import { TextField } from "@mui/material";

import { ChangeEvent, FC } from "react";

interface TextProps {
  value?: string | null;
  width?: string | number;
  label: string;
  type?: string;
  onChange: (value: string) => void;
}

const Text: FC<TextProps> = ({
  value,
  label,
  onChange,
  width,
  type,
  ...rest
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <TextField
      type={type || "text"}
      label={label}
      value={value}
      onChange={handleChange}
      sx={{ minWidth: 150, width: width || "100%" }}
      size="small"
      {...rest}
    />
  );
};

export { Text };
